/**
 * External Users Controller
 */

import { remove } from 'app/helpers/entity'

// controller mixins
ExternalUsersCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * ExternalUsersCtrl controller
 *
 * @class ExternalUsersCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:ExternalUsersCtrl
 */
/* @ngInject */
export default function ExternalUsersCtrl ($scope, ExternalUser, authSvc) {
  var vm = this

  /**
   * Has access channel constant
   *
   * @memberOf mwApp/settings.controller:ExternalUsersCtrl
   * @function
   */
  vm.hasAccess = function (access) { return authSvc.hasAccess(access) }

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  $scope.getters = {
    caseInsensitiveLogin: function (row) {
      return row.login.toLowerCase()
    },
    caseInsensitiveName: function (row) {
      return row.name.toLowerCase()
    },
    caseInsensitiveNetworkName: function (row) {
      return row.network.name.toLowerCase()
    }
  }

  /**
   * External Users list
   *
   * @memberof mwApp/settings.controller:ExternalUsersCtrl
   * @name vm.extUsers
   * @type {models.ExternalUser[]}
   */

  // get external users
  ExternalUser.loadAll()
    .to(vm.extUsers = [])
    .then(() => { $scope.loading = false })

  /**
   * Delete external user
   *
   * @memberof mwApp/settings.controller:ExternalUsersCtrl
   * @param  {models.ExternalUser} user
   */
  vm.deleteExtUser = function (user) {
    user._delete()
      .then(remove(vm.extUsers)(user))
  }
}
